/**
 * Samples Modal
 *
 * @param insertModalTo
 * @param sampleBtn
 * @constructor
 */

const modalBox = `
  <div class="SamplesModal">
    <div class="SamplesModal__overlay"></div>
    <button type="button" class="SamplesModal__close" aria-label="Close">
      <svg xmlns="http://www.w3.org/2000/svg" class="SamplesModal__close__svg" version="1.0" viewBox="0 0 24 24">
        <path class="SamplesModal__close__svg-path" d="M13 12l5-5-1-1-5 5-5-5-1 1 5 5-5 5 1 1 5-5 5 5 1-1z"></path>
      </svg>
    </button>
  </div>
`;

const SamplesModal = ({
  insertModalTo = '[data-samples-section]',
  sampleBtn = '[data-sample-url]',
}) => {
  if (!insertModalTo && !sampleBtn) return;

  const section = document.querySelector(insertModalTo);
  const btn = document.querySelectorAll(sampleBtn);

  if (!section && !btn) return;

  const isiOS = navigator.platform && /iPad|iPhone|iPod/.test(navigator.platform);

  if (!isiOS) {
    section.insertAdjacentHTML('beforeend', modalBox);

    const modal = document.querySelector('.SamplesModal');
    if (!modal) return;

    const iframe = document.createElement('iframe');

    const closePdfContainer = () => {
      modal.classList.remove('show');
      modal.removeChild(iframe);
    };

    const showSample = (el) => {
      const site = window.location.origin;
      iframe.setAttribute('src', site + el.getAttribute('data-sample-url'));
      iframe.setAttribute('width', '100%');
      iframe.setAttribute('height', '100%');
      iframe.setAttribute('frameborder', '0');
      modal.appendChild(iframe);
      modal.classList.add('show');
    };

    [].slice.call(btn).forEach((el) => {
      el.addEventListener('click', (e) => {
        e.preventDefault();
        showSample(el);
      });
    });

    document.querySelector('.SamplesModal__close').addEventListener('click', () => {
      closePdfContainer();
    });

    document.addEventListener('keydown', (e) => {
      if (e.key === 'Escape') {
        closePdfContainer();
      }
    });

    document.querySelector('.SamplesModal__overlay').addEventListener('click', () => {
      closePdfContainer();
    });
  }
};

export default SamplesModal;
